import { createContext, useState } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUserState] = useState(() => {
        return JSON.parse(localStorage.getItem("user")) || null;
    });

    const login = (userData) => {
        localStorage.setItem("user", JSON.stringify(userData));
        setUser(userData);
    };

    const logout = () => {
        localStorage.removeItem("user");
        setUser(null);
    };
    const setUser = (userData) => {
        if (userData) {
            localStorage.setItem("user", JSON.stringify(userData));
        } else {
            localStorage.removeItem("user");
        }
        setUserState(userData);
    };

    return (
        <AuthContext.Provider value={{ user,setUser, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
